import { SearchInput } from '@shared/components'
import { Space } from 'antd'

export const TeamsHeader = () => {
  return (
    <Space>
      <SearchInput />
    </Space>
  )
}
